import keyMirror from 'keymirror';

export const roomDetailsActionTypes = keyMirror({
	GET_ROOM_DETAILS_REQUEST: null,
	GET_ROOM_DETAILS_SUCCESS: null,
	GET_ROOM_DETAILS_ERROR: null,
	CLEAN_ROOM_DETAILS_STATE: null,
});
